// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PGoldOutlinedSvg from "@fishx/icons-svg/es/asn/PGoldOutlined";
import FishxIcon from '../components/FishxIcon';

var PGoldOutlined = function PGoldOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PGoldOutlinedSvg
  }));
};

PGoldOutlined.displayName = 'PGoldOutlined';
export default React.forwardRef(PGoldOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PGoldOutlined.js
// module id = 3446
// module chunks = 0